import React, { useEffect, useState } from 'react';
import './style.css';
import Grid from '@mui/material/Grid';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import http from '../../services/http-service'
import upload from '../../services/upload-files.service'
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import 'react-toastify/dist/ReactToastify.css';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { getErrorResponse } from '../../utils';
import Box from '@mui/material/Box';
import PersonIcon from '@mui/icons-material/Person';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Stack from '@mui/material/Stack';

const Input = styled('input')({
  display: 'none',
});

const theme = createTheme();

export default function EditProfile() {
  const history = useHistory();
  const [userDetails, setUserDetails] = useState({})
  const [language, setLanguage] = useState({})
  // const [selectedFile, setSelectedFile] = useState('')
  const [companyDetails, setCompanyDetails] = useState({})
  const [open, setOpen] = useState(false);
  const fileTypes = ['PNG', 'JPG', 'JPEG']
  const [role, setRole] = useState(localStorage.getItem('loginUser') ? JSON.parse(localStorage.getItem('loginUser')).id : '')

  useEffect(() => {
    getUserDetails()
    // eslint-disable-next-line
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  const goBack = () => {
    history.goBack()
  }

  const onFileChange = event => {
    let file = event.target.files[0]
    if(!fileTypes.includes(getFileExtension(file.name).toUpperCase())){
      toast.error('Please select only .png .jpg .jpeg files.',{
        toastId: "toastId1"
      })
      return
    }
    // setSelectedFile(event.target.files)
    // Create an object of formData
    const formdata = new FormData();
    let data = {
      "company_logo": file,
      "user": JSON.parse(localStorage.getItem('loginUser')).id
    }
    // Update the formData object
    formdata.append("company_logo", file);
    formdata.append("user", JSON.parse(localStorage.getItem('loginUser')).id);

    handleToggle()
    upload('employer/user_profile_details/', 'POST', data)
      .then(res => res.data)
      .then(res => {
        if (res.status) {
          getUserDetails()
          toast.success(res.message,{
            toastId: "toastId2"
          })
        }
        else {
          const error = getErrorResponse(res.message)
          toast.error(error, { toastId: 'toastId3', allowHtml: true })
        }
        handleClose()
      })
      .catch(error => {
        toast.error("Something went wrong!",{
          toastId: "toastId4"
        })
        handleClose()
      });
  };

  const getFileExtension = (filename) => {
    // get file extension
    const extension = filename.split('.').pop();
    return extension;
  }

  const goToPageClick = (route) => {
    history.push(route)
  }

  const handleSubmit = () => {
    let postData = {
      "user": JSON.parse(localStorage.getItem('loginUser')).id,
      "language": language
    }
    handleToggle()
    http('employer/user_profile_details/', 'PUT', postData)
      .then(res => res.data)
      .then(res => {
        if (res.status) {
          
          toast.success(res.message,{
            toastId: "toastId5"
          })
          setTimeout(() => {
            goToPageClick('/dashboard')
          }, 500);
        }
        else {
          const error = getErrorResponse(res.message)
          toast.error(error, { toastId:"toastId6", allowHtml: true })
        }
        handleClose()
      })
      .catch(error => {
        toast.error("Something went wrong!",{
          toastId: "toastId7"
        })
        handleClose()
      });
  };

  const getUserDetails = () => {
    handleToggle()
    http('employer/user_profile_details/', 'GET', '', { 'user_id': JSON.parse(localStorage.getItem('loginUser')).id })
      .then(res => res.data)
      .then(res => {
        if (res.status) {
          setUserDetails(res.data)
          setLanguage(res.data.company.language)
          setCompanyDetails(res.data.company)
        }
        else {
          const error = getErrorResponse(res.message)
          toast.error(error, { toastId:"toastId8" ,allowHtml: true })
        }
        handleClose()
      })
      .catch(error => {
        toast.error("Something went wrong!",{
          toastId: "toastId9"
        })
        handleClose()
      });
  };

  return (
    <div className='mainAppDiv'>

      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastContainer />
        <div className='editFormDiv'>
          <Typography className='AdminAddEmployerHeadding editTitle'>
            Edit Profile
            <CloseIcon className='closeIcon' onClick={goBack} />
          </Typography>

          <Typography>Profile</Typography>

          <div className='profileBlock'>
            {companyDetails.logo ? (
              <img className="editProfileImg" src={companyDetails.logo} alt="img" />
            ) : (<PersonIcon className="editProfileIcon" />)}
            <Stack direction="row" alignItems="center" className='profileCamra'>
              <label htmlFor="icon-button-file">
                <Input id="icon-button-file" type="file" onChange={onFileChange} accept="image/x-png,image/gif,image/jpeg" />
                <IconButton color="primary" aria-label="upload picture" component="span">
                  <PhotoCamera />
                </IconButton>
              </label>
            </Stack>
          </div>

          <Box component="form" noValidate autoComplete="off" className='editProfileForm' mt={3}>

            <Typography>Full Name</Typography>
            <TextField inputProps={{ readOnly: true }} type="text" mt={1} id="fullname" variant="outlined" fullWidth value={userDetails.first_name} />

            <Typography mt={2}>Email</Typography>
            <TextField inputProps={{ readOnly: true }} type="email" mt={1} id="email" variant="outlined" fullWidth value={userDetails.email} />

            <Typography mt={2}>Phone Number</Typography>
            <TextField inputProps={{ readOnly: true }} type="tel" mt={1} id="phoneNumber" variant="outlined" fullWidth value={userDetails.phone_number} />

            <Typography mt={2}>Password</Typography>
            <TextField inputProps={{ readOnly: true }} type="password" mt={1} id="password" variant="outlined" fullWidth value={userDetails.password} />

            <Typography mt={2}>Language</Typography>
            <FormControl fullWidth>
              <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group" className='border radioGroup' fullWidth >
                <FormControlLabel checked={language === 'english'} value="english" control={<Radio />} label="English" onChange={(e) => { setLanguage(e.target.value); userDetails.company.language = e.target.value }} />
                <FormControlLabel checked={language === 'french'} value="french" control={<Radio />} label="French" onChange={(e) => { setLanguage(e.target.value); userDetails.company.language = e.target.value }} />
              </RadioGroup>
            </FormControl>

           { role != 1 ? 
           <>
           <Typography mt={2}>Company Name</Typography>
            <TextField inputProps={{ readOnly: true }} type="text" mt={1} id="fullname" variant="outlined" fullWidth value={companyDetails.name} />

            <Typography mt={2}>Company Address</Typography>
            <TextField inputProps={{ readOnly: true }} type="text" mt={1} id="fullname" variant="outlined" fullWidth value={companyDetails.address} />

            <Typography mt={2}>Company Phone Number</Typography>
            <TextField inputProps={{ readOnly: true }} type="tel" mt={1} id="phoneNumber" variant="outlined" fullWidth value={userDetails.phone_number} />

            <Typography mt={2}>Company Email Address</Typography>
            <TextField inputProps={{ readOnly: true }} type="email" mt={1} id="email" variant="outlined" fullWidth value={userDetails.email} />
            </>
          : <></> }

            <div className='btnDiv'>
              <Grid container spacing={3} className='justifyEnd' sx={{ justifyContent: 'flex-end' }}>
                <Grid item={true} xs={12} className='gridbtnSubmit'>
                  <button type='button' className='btnSubmit btnCancel' onClick={goBack}>Cancel</button>
                  <button type='button' className='btnSubmit' onClick={handleSubmit}>Submit</button>
                </Grid>
              </Grid>
            </div>

          </Box>
        </div>

        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
          <CircularProgress color="inherit" />
        </Backdrop>

      </ThemeProvider>
    </div>

  );
}